export const lastYearColorTailwind = 'bg-[#5280ff]';
export const thisYearColor = '#15bd15';
export const thisYearColorTailwind = 'bg-[#15bd15]';
export const thisYearEstimatesColor = '#87ff87';
export const thisYearEstimatesColorTailwind = 'bg-[#87ff87]';
